// todo: Use UIP/WebStoreApi client from this library instead of @gn-audio/core after full site migration to Next.js
import { IAuthorizationSetting } from '@gn-audio/core/api/site-settings/models';
import { buildMsalConfig, setUipConfig } from '@gn-audio/core/auth/uip';
import { setWebStoreApiConfig } from '@gn-audio/core/auth/web-store-api';
import { SiteContext as LegacySiteContext } from '@gn-audio/core/common/enums';

import { SiteContext } from '../common';
import { SiteSettings } from '../site-settings/models';

const configureWebStoreApi = (
  authSettings: IAuthorizationSetting,
  siteContext: SiteContext,
  locale: string
): void => {
  if (!authSettings?.webStoreAPIBaseUrl) {
    console.warn('WebStore API Base URL is not defined');
    return;
  }

  setWebStoreApiConfig({
    baseUrl: authSettings.webStoreAPIBaseUrl,
    marketLocale: locale,
    siteContext: siteContext as unknown as LegacySiteContext,
    scopes: authSettings.webStoreAPIScopes ?? [],
    storage: localStorage,
  });
};

const configureUip = (authSettings: IAuthorizationSetting) => {
  setUipConfig(buildMsalConfig(authSettings));
};

export const configureAuthorization = (
  siteSettings: SiteSettings,
  siteContext: SiteContext,
  locale: string
) => {
  try {
    const authSettings = siteSettings.authorization;

    if (!authSettings) {
      console.warn('No authorization settings were found');
      return;
    }

    configureUip(authSettings);
    configureWebStoreApi(authSettings, siteContext, locale);
  } catch (error) {
    console.error('Error bootstrapping authorization clients:', error);
  }
};
